// @flow

/**
 * Wraps react-helmet with some security features.
 */
import React from 'react';
import { Helmet } from 'react-helmet';
import striptags from 'striptags';
import { omitBy, isEmpty, isNil, map, mapValues } from 'lodash';

type Props = {
  title?: string,
  link?: Array<{| rel: string, href: string |}>,
  meta?: Array<{| name?: string, content: string, property?: string |}>,
  script?: Array<{| type: string, innerHTML: string |}>
};

const stripObject = (o: ?Object) => mapValues(o, v => striptags(v));
const stripArray = (a: ?Array<Object>) => map(a, stripObject);
const omitEmpties = o => omitBy(o, isEmpty);

export function stripProps(props: Props) {
  if (isNil(props)) {
    return {};
  }
  const title = props.title ? striptags(props.title) : null;
  const link = stripArray(props.link);
  const meta = stripArray(props.meta);
  const script = stripArray(props.script);
  return omitEmpties({ title, link, meta, script });
}

export function SafetyHelmet(props: Props) {
  return <Helmet {...stripProps(props)} />;
}
